import React from "react";
import mainLogoSvg from "../../assets/img/Main logo.png";
import svg71 from "../../assets/svg/svg71.svg";
import svg72 from "../../assets/svg/svg72.svg";
import svg73 from "../../assets/svg/svg73.svg";

import { Divider } from "antd";

function Footer() {
  return (
    <div className="bg-white lg:py-[3.75rem] py-3 lg:px-[6.94rem] px-3 w-full">
      <div className="flex lg:flex-row flex-col justify-between gap-y-[1.25rem]">
        <div>
          <img src={mainLogoSvg} alt="mainLogoSvg" className="object-contain" />
          <div className="flex items-center gap-[2.12rem] lg:mt-[7.75rem] mt-[1.25rem]">
            <img src={svg71} alt="twiter-icon"/>
            <img src={svg72} alt="facebook-icon"/>
            <img src={svg73} alt="instagram-icon"/>
          </div>
        </div>

        <div>
          <span className="text-[#424242] text-[1rem] font-[600] font-sora">
            Useful Links
          </span>
          <ul className="space-y-2 mt-[.88rem]">
            <li className="text-[#424242] text-[.875rem] font-[400] font-sora">
              Projects
            </li>
            <li className="text-[#424242] text-[.875rem] font-[400] font-sora">
              Production reports
            </li>
            <li className="text-[#424242] text-[.875rem] font-[400] font-sora">
              Schemes
            </li>
          </ul>
        </div>

        <div>
          <span className="text-[#424242] text-[1rem] font-[600] font-sora">
            Contact Us
          </span>
          <ul className="space-y-2 mt-[.88rem]">
            <li className="text-[#424242] text-[.875rem] font-[400] font-sora">
              State Department for Irrigation
            </li>
            <li className="text-[#424242] text-[.875rem] font-[400] font-sora">
              Maji House, Upper Hill, Off Ngong road, Nairobi
            </li>
            <li className="text-[#424242] text-[.875rem] font-[400] font-sora">
              P.O BOX 49720 – 00100, Nairobi
            </li>
            <li className="text-[#424242] text-[.875rem] font-[400] font-sora !mt-[2rem]">
              Telephone: +254 020 2716103, 4900000
            </li>
            <li className="text-[#424242] text-[.875rem] font-[400] font-sora">
              Fax: +254 020 2727622
            </li>
            <li className="text-[#424242] text-[.875rem] font-[400] font-sora">
              Email: ps@irrigationkenya.go.ke
            </li>
            <li className="text-[#424242] text-[.875rem] font-[400] font-sora">
              Website:{" "}
              <a
                href="https://www.irrigation.go.ke"
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
              >
                irrigation.go.ke
              </a>
            </li>
            <li className="text-[#424242] text-[.875rem] font-[400] font-sora">
              Follow us on Facebook
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-[4.75rem]">
        <Divider />
      </div>

      <div className="text-[#424242] text-[.875rem] font-[400] font-sora flex items-center justify-between pt-[2.5rem]">
        <span>
          © Copyright {new Date().getFullYear()}, All Rights Reserved{" "}
        </span>
        Terms of Service | Privacy Policy
      </div>
    </div>
  );
}

export default Footer;
